import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseComponent } from '../BaseComponent.js';
const renderer = (color) => (_jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22 12.25C22 12.5261 21.7761 12.75 21.5 12.75H2.5C2.22386 12.75 2 12.5261 2 12.25V11.75C2 11.4739 2.22386 11.25 2.5 11.25H21.5C21.7761 11.25 22 11.4739 22 11.75V12.25Z', fill: color }));
export const Minus = forwardRef(function Minus({ dataTestId, ...props }, ref) {
    return _jsx(BaseComponent, { ref: ref, dataTestId: dataTestId ?? 'minus-icon-svg', iconRender: renderer, ...props });
});
